<template>
    <div
        v-if="isVisible"
        class="w-full h-full fixed bg-black/30 top-0 left-0 z-10 flex items-center justify-center"
        tabindex="-1"
        aria-modal="true"
        role="dialog"
        @click.exact.self="isVisible = false"
    >
        <div class="rounded bg-base-100 shadow-lg cursor-auto flex flex-col p-3">
            <h2 class="font-bold">
                {{ $t('sub-account.confirm-popup.title') }}
            </h2>
            <span class="my-4 mr-6">
                {{ $t('sub-account.confirm-popup.message') }} {{ isCustomer ? 'kunden' : 'leverandøren' }} <b> {{ entityName }} </b>?
            </span>
            <div class="flex justify-end gap-2 mt-1">
                <UButton
                    tabindex="0"
                    variant="outline"
                    color="neutral"
                    class="w-30 flex justify-center"
                    data-cy="cancel-delete-button"
                    @click="handleCancel"
                >
                    {{ $t('sub-account.confirm-popup.cancel') }}
                </UButton>
                <UButton
                    color="error"
                    data-cy="confirm-delete-button"
                    class="w-30 flex justify-center"
                    @click="handleConfirm"
                >
                    {{ $t('sub-account.confirm-popup.delete') }} {{ isCustomer ? 'kunde' : 'leverandør' }}
                </UButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {CUSTOMERS, SUPPLIERS} from '@/subaccount'
import {usePanelManager} from '@tritt/multipanel'
import {inject, Ref} from 'vue'

const isVisible = defineModel<Boolean>('isVisible')
const emit = defineEmits(['handleCancel', 'handleConfirm'])

const { setPanelPath } = usePanelManager()
const panelId: Ref<number> | undefined = inject('panelId')


const props = defineProps({
    isCustomer: {
        type: Boolean,
        required: true
    },
    entityName: {
        type: String,
        required: true
    }
})

const handleCancel = () => {
    emit('handleCancel')
    hidePopup()
}

const handleConfirm = () => {
    emit('handleConfirm')
    hidePopup()

    const path = props.isCustomer ? CUSTOMERS : SUPPLIERS
    setPanelPath({...path, panelId: panelId?.value})
}

const hidePopup = () => {
    isVisible.value = false
}

</script>
<style scoped>

</style>